import React from 'react'
import { FAQHeading } from './FAQHeading'
import { FAQRow } from './FAQRow'

import '../../styles/MatchTabsModule/FAQSection.scss'

export interface FAQEntry {
  question: string
  answer: string
}

interface FAQSectionProps {
  heading: string
  faqs: FAQEntry[]
}

export const FAQSection = ({ heading, faqs }: FAQSectionProps) => {
  if (faqs.length === 0) return null

  return (
    <section className="faq-section">
      <FAQHeading text={heading} />
      <ul className="faq-section__list">
        {faqs.map((entry) => (
          <li key={entry.question} className="faq-section__item">
            <FAQRow question={entry.question} answer={entry.answer} />
          </li>
        ))}
      </ul>
    </section>
  )
}
